import $ from 'jquery';
import tabs from 'tabs';
import chunk from 'chunk';

(function($) {

  // Implement tabs
  const containers = document.querySelectorAll('.document-picker');
  containers.forEach((container) => {
    tabs(container);
  });

  // Setup paginated tables
  const tables = $('.document-picker__table');

  function replaceTableContentsWithChunk(table, chunk) {
    const body = $(table).children('tbody');  
    const content = chunk.map((row) => {

      const links = row.files.map(({ file }) => {
        const pieces = file.split('.');
        return `<a href="${file}" download>${pieces[pieces.length - 1]}</a>`;
      }).join('');

      return `<tr>
        <td>${row.date}</td>
        <td>${row.description}</td>
        <td>${links}</td>
      </tr>`;
    });

    body.html(content);
  }

  tables.each((index, elem) => {
    
    const table = $(elem);
    const chunks = chunk(table.data('docs'), 6);
    const total = table.data('docs').length;
    
    if(!chunks || total < 1) {
      table.parent().html('<div class="document-picker__empty">No files found</div>')
      return;
    }

    // Otherwise we pass the first chunk through
    replaceTableContentsWithChunk(table, chunks[0]);

    if(total) {
      table.children('tfoot').html(`
        <tr>
          <th colspan="3">
            <span class="document-picker__count">1 - ${chunks[0].length}</span> of <span class="document-picker__total">${total}</span>
            <span class="document-picker__buttons">
              <button class="document-picker__prev" disabled>
                Prev
              </button>
              <button class="document-picker__next" ${(total < 7) ? 'disabled' : null}>
                Next
              </button>
            </span>
          </th>
        </tr>
      `);
    }

  });

  function changePickerPage(table, page) {

    table.data('page', page);

    let docs = table.data('docs');
    
    const year = table.find('select').val();
    if(year != 'all') {
      docs = docs.filter(({ date }) => date.includes(year));
    }

    const total = docs.length;
    const chunks = chunk(docs, 6);
    const rows = chunks[page];
    replaceTableContentsWithChunk(table, rows);

    let start = ((page) * 6) + 1;
    const end = (start - 1) + rows.length;
    
    const countContainer = table.find('.document-picker__count');
    countContainer.html(`${start} - ${end}`);

    table.find('.document-picker__total').html(total);

    return { start, end, total };

  }

  $('.document-picker__table select').on('change', function() {
    const table = $(this).parents('.document-picker__table');
    const { end, total } = changePickerPage(table, 0);
    table.find('.document-picker__next').attr('disabled', (end == total));
  });

  $('.document-picker__next').on('click', function() {

    const table = $(this).parents('.document-picker__table');
    let page = table.data('page');
    page += 1;

    const { end, total } = changePickerPage(table, page);
    $(this).siblings('.document-picker__prev').attr('disabled', false);
    if(end == total) $(this).attr('disabled', true);

  });

  $('.document-picker__prev').on('click', function() {

    const table = $(this).parents('.document-picker__table');
    let page = table.data('page');
    page -= 1;

    changePickerPage(table, page);
    const { start } = changePickerPage(table, page);
    $(this).siblings('.document-picker__next').attr('disabled', false);
    if(start == 1) $(this).attr('disabled', true);

  });

  $('.tab-panes__accordion__button').on('click', function() {

    $('.tab-pane').slideUp();

    const expanding = $(this).text().trim() == 'Expand';

    $('.tab-panes__accordion__button')
      .text('Expand')
      .addClass('tab-panes__accordion__button--expand')
      .removeClass('tab-panes__accordion__button--collapse');

    if(expanding) {
      $(this)
        .text('Collapse')
        .addClass('tab-panes__accordion__button--collapse')
        .removeClass('tab-panes__accordion__button--expand')
        .parent()
        .next('.tab-pane')
        .slideDown();
    }
    
  });

  // $('.tab-panes__accordion__button--collapse').on('click', function() {

  //   $('.tab-pane').slideUp();

  //   $(this)
  //     .text('Expand')
  //     .addClass('tab-panes__accordion__button--expand')
  //     .removeClass('tab-panes__accordion__button--collapse');

  // });

})($);


// WEBPACK FOOTER //
// ./scripts/document-picker.js